module.exports = __webpack_public_path__ + "static/media/download_img_2.b8dc9280.jpg";